import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { Image, Stack } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";

import "./LoadingOverlay.scss";
import LoadingAnimation from "../../assets/animations/loader.json";
import ImageGamePad from "../../images/game-controller.svg";
import LoadingDots from "../LoadingDots/LoadingDots";
import LoadingSpinner from "../Payments/LoadingSpinner/LoadingSpinner";
import { ThemeVariant } from "../../utils/constants/generic-types";

export enum OverlayVariant {
  BLOCKS,
  GAMEPAD,
  GATHERING_INFO,
  SPINNER,
}

function LoadingOverlay({
  variant = OverlayVariant.BLOCKS,
  loadingText,
  theme = ThemeVariant.LIGHT,
}: {
  variant?: OverlayVariant;
  loadingText?: string;
  theme?: ThemeVariant;
}) {
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    if (variant !== OverlayVariant.GATHERING_INFO) return;

    const intervalId = setInterval(() => {
      setProgress((prev) => prev + 30);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [variant]);

  return (
    <>
      <div
        className={`MobileOnly loading-overlay-content ${
          theme === ThemeVariant.DARK ? "dark" : "light"
        }`}
      >
        {variant === OverlayVariant.BLOCKS && (
          <div className="lottie-container">
            <Lottie animationData={LoadingAnimation} loop={true} />
          </div>
        )}
        {variant === OverlayVariant.GAMEPAD && (
          <div className="content">
            <Image src={ImageGamePad} className="spin-right" />
            <div className="d-flex mt-3">
              <p className="loading">Loading</p>
              <div className="d-flex align-items-end pb-1">
                <LoadingDots dotStyles={{ background: "white" }} />
              </div>
            </div>
          </div>
        )}
        {variant === OverlayVariant.GATHERING_INFO && (
          <div className="content MobileOnly">
            <Image src={ImageGamePad} />
            <div className="d-flex mt-3">
              <p className="loading">
                {loadingText || "Gathering Information"}
              </p>
            </div>
            <div className="d-flex justify-content-center mt-2">
              <ProgressBar now={progress} className="progress-bar-custom" />
            </div>
          </div>
        )}
        {variant === OverlayVariant.SPINNER && (
          <Stack gap={3} className="align-items-center spinner MobileOnly">
            <LoadingSpinner width={48} height={48} />
            <p className="loading-text">{loadingText}</p>
          </Stack>
        )}
      </div>
      <div className="loader-overlay MobileOnly" />
    </>
  );
}

export default LoadingOverlay;
